import React from 'react';
import { CProgress } from '@coreui/react';

const WeightWidget = ({ weight }) => (
  <div>
    <div className="mb-2">Weight</div>
    <strong>{weight} LBS (60%)</strong>
    <CProgress className="CProgress-xs mt-2" color="warning" value={60} />
  </div>
);

export default WeightWidget;


